import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { ResourcesLoaderService } from "digital-core";

@Injectable()
export class ImagesResolver  {
    constructor(private resourcesLoader: ResourcesLoaderService) { }
    resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot) {
        return this.resourcesLoader.loadDocuments();
    }
}
